import React from "react";
import { Link } from "react-router-dom";

const icons = [
  "flaticon-money-1",
  "flaticon-promotion",
  "flaticon-vector",
  "flaticon-web-programming",
  "flaticon-headhunting",
  "flaticon-rocket-ship",
  "flaticon-support-1",
  "flaticon-first-aid-kit-1",
  "flaticon-car",
];

const JobCategories = ({ categories = [], stats }) => {
  return (
    <section className="job-categories">
      <div className="auto-container">
        <div className="sec-title text-center">
          <h2>Popular Job Categories</h2>
          <div className="text">{stats?.active_jobs ?? 0} jobs live - {stats?.jobs_added_today ?? 0} added today.</div>
        </div>

        <div className="row wow fadeInUp">
          {categories.map((category, index) => (
            <div className="category-block col-lg-4 col-md-6 col-sm-12" key={category.category}>
              <div className="inner-box">
                <div className="content">
                  <span className={`icon ${icons[index % icons.length]}`}></span>
                  <h4><Link to={`/jobs?category=${encodeURIComponent(category.category)}`}>{category.category}</Link></h4>
                  <p>({category.open_positions} open positions)</p>
                </div>
              </div>
            </div>
          ))}

          {categories.length === 0 && (
            <div className="col-lg-12">
              <div className="employee-empty-state">No categories available yet.</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default JobCategories;
